export default "__VITE_ASSET__BAcaQaIY__"